import { useTestIncomingPostbackMutation } from "api/TenantSlug/IncomingPostback/hooks";
import { BaseTestForm } from "components/Forms/BaseTestForm/BaseTestForm";
import { TestResult } from "components/Forms/BaseTestForm/TestResult";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormId } from "types/models";

import IncomingPostbackDataOptional = App.Data.IncomingPostbackDataOptional;

interface IncomingPostbackTestFormProps {
    incomingPostback: IncomingPostbackDataOptional;
}

export const IncomingPostbackTestForm: FC<IncomingPostbackTestFormProps> = ({ incomingPostback }) => {
    const { t: tF } = usePaldockTranslation("forms.incoming-postback-test");
    const testMut = useTestIncomingPostbackMutation();

    const resetTest = () => {
        testMut.reset();
    };

    return (
        <BaseTestForm
            formId={FormId.IncomingPostbackTestForm}
            entityId={incomingPostback.id ?? ""}
            entityFilterKey="incoming_postback_id"
            loadingMessage={tF("messages.processing")}
            errorMessage={tF("messages.test_failed")}
            stepValidationMessage={tF("messages.select_first_step")}
            testMutation={{
                mutate: ({ first_step_id, query_values, header_values, body_values }, options) => {
                    testMut.mutate(
                        {
                            incomingPostbackId: incomingPostback.id ?? "",
                            request: { first_step_id, query_values, header_values, body_values },
                        },
                        options
                    );
                },
                isPending: testMut.isPending,
                isSuccess: testMut.isSuccess,
                isError: testMut.isError,
                error: testMut.error ? { message: testMut.error.message } : undefined,
                reset: testMut.reset,
            }}
            onTestSuccess={(series) => <TestResult series={series} resetTest={resetTest} />}
        />
    );
};
